import { httpClient } from '@/configs/axios.config'
import type {
  FieldDefinition,
  FieldDefinitionList,
  FieldDefinitionSearch,
  ViewEntityType,
} from '@/types/api'

/**
 * Search field definitions with filters and pagination
 */
export async function searchFieldDefinitions(
  params: FieldDefinitionSearch
): Promise<FieldDefinitionList> {
  const response = await httpClient.post<FieldDefinitionList>(
    '/field-definitions/search',
    params
  )
  return response.data
}

/**
 * Get field definitions for a specific entity type
 */
export async function getFieldDefinitionsByEntity(
  entityType: ViewEntityType,
  limit = 100
): Promise<FieldDefinition[]> {
  const response = await searchFieldDefinitions({
    limit,
    filters: [
      {
        field: 'entityType',
        op: 'eq',
        value: entityType,
        logicalOp: 'AND',
      },
    ],
  })
  return response.data
}

/**
 * Get a single field definition by ID
 */
export async function getFieldDefinition(id: string): Promise<FieldDefinition> {
  const response = await httpClient.get<FieldDefinition>(
    `/field-definitions/${id}`
  )
  return response.data
}
